app({
  appId: '2PZ2M6W8LW',
  apiKey: 'c8e60316efb533d0d2f2b5150ad0c2a4',
  indexName: 'shopify_products',
  searchParameters: {
    hitsPerPage: 10,
  },
});

function app(opts) {
  // ---------------------
  //
  //  Init
  //
  // ---------------------
  const search = instantsearch({
    searchClient: algoliasearch(opts.appId, opts.apiKey),
    indexName: opts.indexName,
    routing: true,
    searchFunction: opts.searchFunction,
  });

  // ---------------------
  //
  //  Default widgets
  //
  // ---------------------
  search.addWidgets([
    instantsearch.widgets.searchBox({
      container: '#search-input',
      placeholder: 'Search for product',
    }),
    instantsearch.widgets.infiniteHits({
      container: '#hits',
      hitsPerPage: opts.searchParameters.hitsPerPage,
      templates: {
        item: `
          <a href="/products/{{handle}}">
            <div class="hit">
              <div class="hit-image">
                <img src="{{image}}" alt="{{title}}">
              </div>
              <div class="hit-content">
                <div class="hit-name">
                  {{title}}
                </div>
                <p class="hit-description">{{ _highlightResult.body_html_safe.value }}</p>
                <div class="hit-price">
                {{#compare_at_price}}
                  LOGANS $ {{price}} <span class="hit-compare-price">RRP $ {{compare_at_price_string}}</span>
                {{/compare_at_price}}
                {{^compare_at_price}}
                  $ {{price}}
                {{/compare_at_price}}
                </div>
              </div>
            </div>
          </a>
        `,
        empty: `
          <div id="no-results-message">
            <p>We didn't find any results for the search <em>"{{query}}"</em>.</p>
          </div>`,
      },
      transformItems(items) {
        var reg=/<[^<>]+>/g
        return items.map(item => {
          /* eslint-disable no-param-reassign */
          item.price = item.price.toLocaleString();
          item.compare_at_price_string = item.compare_at_price.toLocaleString();
          item.starsLayout = getStarsHTML(item.rating);
          item.categories = getCategoryBreadcrumb(item);
          item._highlightResult.body_html_safe.value = escape2Html(item._highlightResult.body_html_safe.value).replace(reg,'')
          return item;
        });
      },
    }),
    instantsearch.widgets.infiniteHits({
      container: '#hits-grid',
      hitsPerPage: opts.searchParameters.hitsPerPage,
      templates: {
        item: `
          <div>
            <a href="/products/{{handle}}">
              <div class="hit-grid-image">
                <img src="{{image}}" alt="{{title}}">
              </div>
              <div class="hit-content">
                <div class="hit-name">
                    {{title}}
                </div>
                <div>
                {{#compare_at_price}}
                  <div class="hit-logans-price">
                    LOGANS
                    <span class="uni-hit-currency">$</span>
                    <span class="uni-hit-price">{{price}}</span>
                  </div>
                  <div class="hit-compare-price">
                    RRP $ {{compare_at_price_string}}
                  </div>
                {{/compare_at_price}}
                {{^compare_at_price}}
                  <span class="uni-hit-currency">$</span>
                  <span class="uni-hit-price">{{price}}</span>
                {{/compare_at_price}}
                </div>
              </div>
            </a>
          </div>
        `,
        empty: `
          <div id="no-results-message">
            <p>We didn't find any results for the search <em>"{{query}}"</em>.</p>
          </div>`,
      },
      transformItems(items) {
        return items.map(item => {
          /* eslint-disable no-param-reassign */
          item.price = item.price.toLocaleString();
          item.compare_at_price_string = item.compare_at_price.toLocaleString();
          item.starsLayout = getStarsHTML(item.rating);
          item.categories = getCategoryBreadcrumb(item);
          return item;
        });
      },
    }),

    // instantsearch.widgets.stats({
    //   container: '#stats',
    //   templates: {
    //     text: `
    //       {{#areHitsSorted}}
    //         {{#hasNoSortedResults}}No relevant results{{/hasNoSortedResults}}
    //         {{#hasOneSortedResults}}1 relevant result{{/hasOneSortedResults}}
    //         {{#hasManySortedResults}}{{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results{{/hasManySortedResults}}
    //         sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
    //       {{/areHitsSorted}}
    //       {{^areHitsSorted}}
    //         {{#hasNoResults}}No results{{/hasNoResults}}
    //         {{#hasOneResult}}1 result{{/hasOneResult}}
    //         {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results{{/hasManyResults}}
    //       {{/areHitsSorted}}
    //       found
    //     `,
    //   },
    // }),
    instantsearch.widgets.sortBy({
      container: '#sort-by',
      items: [
        {
          value: opts.indexName,
          label: 'Most relevant',
        },
        {
          value: `${opts.indexName}_price_asc`,
          label: 'Lowest price',
        },
        {
          value: `${opts.indexName}_price_desc`,
          label: 'Highest price',
        },
      ],
    }),
    // instantsearch.widgets.pagination({
    //   container: '#pagination',
    //   scrollTo: '#search-input',
    // }),

    // ---------------------
    //
    //  Filtering widgets
    //
    // ---------------------
    instantsearch.widgets.panel({
      templates: {
        header: getHeaderTemplate('category'),
      },
    })(instantsearch.widgets.hierarchicalMenu)({
      container: '#search-categories',
      attributes: [
        'named_tags.lvl0',
        'named_tags.lvl1',
        'named_tags.lvl2',
        'named_tags.lvl3',
      ],
      showParentLevel: true,
      limit: 50,
      templates: {
        item:
          '<a href="{{url}}" class="facet-item {{#isRefined}}active{{/isRefined}}"><span class="facet-name"><i class="fa fa-angle-right"></i> {{label}}</span class="facet-name"></a>',
      },
      transformItems(items) {
        items = titleUpperEach(items)
        return items
      },
    }),
    instantsearch.widgets.panel({
      templates: {
        header: getHeaderTemplate('brand'),
      },
    })(instantsearch.widgets.refinementList)({
      container: '#brand',
      attribute: 'vendor',
      limit: 5,
      showMore: true,
      showMoreLimit: 50,
      searchable: true,
      searchablePlaceholder: 'Search for brand',
      templates: {
        searchableNoResults:
          '<div class="sffv_no-results">No matching brands.</div>',
        showMoreText: `
          {{#isShowingMore}}
            <span class="isShowingLess"></span>
            Show less
          {{/isShowingMore}}
          {{^isShowingMore}}
            <span class="isShowingMore"></span>
            Show more
          {{/isShowingMore}}
        `,
      },
    }),
    instantsearch.widgets.panel({
      templates: {
        header: getHeaderTemplate('price'),
      },
    })(instantsearch.widgets.rangeSlider)({
      container: '#price',
      attribute: 'price',
      tooltips: {
        format(rawValue) {
          return `$${Math.round(rawValue).toLocaleString()}`;
        },
      },
    }),
  ]);

  search.start();
}

function titleUpperEach(items){
  if(items && items.length > 0) {
    items.forEach(function(row){
      row.label = row.label.toLowerCase().split(' ').map(item=>{
        return item.replace(item.charAt(0),item[0].toUpperCase())
      }).join(' ')
      if(row.data && row.data.length > 0){
        titleUpperEach(row.data)
      }
    })
  }
  return items
}

function escape2Html(str) {
  // console.log(str);
  var temp = "";
  if(str.length == 0) return "";
  temp = str.replace("&amp;","&");
  temp = temp.replace("amp;"," ");
  temp = temp.replace("&amp;amp;","&");
  temp = temp.replace("&lt;","<");
  temp = temp.replace("&lt;",">");
  temp = temp.replace("&nbsp;"," ");
  temp = temp.replace("&#39;","\'");
  temp = temp.replace("&quot;","\"");
  return temp;
}

$("#myModal").scroll(function(){
  // scroll at bottom
  var modalScrollTop = $(this).scrollTop();
  var modalHeight = $(this).height();
  var contentHeight = $('.search-content').height();
  if(modalScrollTop + modalHeight == Math.round(contentHeight)){
    $(".ais-InfiniteHits-loadMore").trigger("click");
  }
});

$(".ais-SearchBox-input").keydown(function(event){
  //console.log(event)
  if(event.keyCode ==13){
    var url = location.search
    $(location).attr('href', '/search'+url);
  }
});

$('#hit-grid-view').click(function (e) {
  e.preventDefault();
  $('#hit-grid-view').css("color", "#21243d");
  $('#hit-list-view').css("color", "#ccc");
  $('#hits-grid').css('display', 'block');
  $('#hits').css('display', 'none');
});

$('#hit-list-view').click(function (e) {
  e.preventDefault();
  $('#hit-grid-view').css("color", "#ccc");
  $('#hit-list-view').css("color", "#21243d");
  $('#hits-grid').css('display', 'none');
  $('#hits').css('display', 'block');
});

$('#filter-btn').click(function (e) {
  e.preventDefault();
  $('#left-column').addClass("left-modal-show")
  $('#filter-close').addClass("left-modal-show")
  $('#search-categories .fa-angle-up').addClass("categoryHide");
  $('#search-categories .fa-angle-down').removeClass("categoryHide");
  $('#search-categories .ais-Panel-body').removeClass("categoryHide");
  $('#brand .fa-angle-up').removeClass("categoryHide");
  $('#brand .fa-angle-down').addClass("categoryHide");
  $('#brand .ais-Panel-body').addClass("categoryHide");
  $('#price .fa-angle-up').removeClass("categoryHide");
  $('#price .fa-angle-down').addClass("categoryHide");
  $('#price .ais-Panel-body').addClass("categoryHide");
});
$('#filter-close').click(function (e) {
  e.preventDefault();
  $('#left-column').removeClass("left-modal-show")
  $('#filter-close').removeClass("left-modal-show")
  // $('#left-column').css("display", "none");
  // $('#filter-close').css("display", "none");
});

// ---------------------
//
//  Helper functions
//
// ---------------------
function getTemplate(templateName) {
  return document.querySelector(`#${templateName}-template`).innerHTML;
}

function getHeaderTemplate(name) {
  return `<button class="ais-header"><h5>${name}</h5><div class="ais-Panel-collapseButton"><i class="fa fa-angle-up categoryHide" aria-hidden="true"></i><i class="fa fa-angle-down" aria-hidden="true"></i></div></button>`;
}

$('#search-categories .ais-header').click(function (e) {
  e.preventDefault();
  // console.log(document.body.scrollWidth)
  // console.log($(document.body).outerWidth())
  $("#search-input input").focus();
  if($('#search-categories .ais-Panel-body').hasClass('categoryHide')) {
    $('#search-categories .fa-angle-up').addClass("categoryHide");
    $('#search-categories .fa-angle-down').removeClass("categoryHide");
    $('#search-categories .ais-Panel-body').removeClass("categoryHide");
  }
  else {
    $('#search-categories .fa-angle-up').removeClass("categoryHide");
    $('#search-categories .fa-angle-down').addClass("categoryHide");
    $('#search-categories .ais-Panel-body').addClass("categoryHide");
  }
  if($(document.body).outerWidth()<=768) {
    $('#brand .fa-angle-up').removeClass("categoryHide");
    $('#brand .fa-angle-down').addClass("categoryHide");
    $('#brand .ais-Panel-body').addClass("categoryHide");
    $('#price .fa-angle-up').removeClass("categoryHide");
    $('#price .fa-angle-down').addClass("categoryHide");
    $('#price .ais-Panel-body').addClass("categoryHide");
  }
});
$('#brand .ais-header').click(function (e) {
  e.preventDefault();
  if($('#brand .ais-Panel-body').hasClass('categoryHide')) {
    $('#brand .fa-angle-up').addClass("categoryHide");
    $('#brand .fa-angle-down').removeClass("categoryHide");
    $('#brand .ais-Panel-body').removeClass("categoryHide");
  }
  else {
    $('#brand .fa-angle-up').removeClass("categoryHide");
    $('#brand .fa-angle-down').addClass("categoryHide");
    $('#brand .ais-Panel-body').addClass("categoryHide");
  }
  if($(document.body).outerWidth()<=768) {
    $('#search-categories .fa-angle-up').removeClass("categoryHide");
    $('#search-categories .fa-angle-down').addClass("categoryHide");
    $('#search-categories .ais-Panel-body').addClass("categoryHide");
    $('#price .fa-angle-up').removeClass("categoryHide");
    $('#price .fa-angle-down').addClass("categoryHide");
    $('#price .ais-Panel-body').addClass("categoryHide");
  }
});
$('#price .ais-header').click(function (e) {
  e.preventDefault();
  if($('#price .ais-Panel-body').hasClass('categoryHide')) {
    $('#price .fa-angle-up').addClass("categoryHide");
    $('#price .fa-angle-down').removeClass("categoryHide");
    $('#price .ais-Panel-body').removeClass("categoryHide");
  }
  else {
    $('#price .fa-angle-up').removeClass("categoryHide");
    $('#price .fa-angle-down').addClass("categoryHide");
    $('#price .ais-Panel-body').addClass("categoryHide");
  }
  if($(document.body).outerWidth()<=768) {
    $('#search-categories .fa-angle-up').removeClass("categoryHide");
    $('#search-categories .fa-angle-down').addClass("categoryHide");
    $('#search-categories .ais-Panel-body').addClass("categoryHide");
    $('#brand .fa-angle-up').removeClass("categoryHide");
    $('#brand .fa-angle-down').addClass("categoryHide");
    $('#brand .ais-Panel-body').addClass("categoryHide");
  }
});


function getCategoryBreadcrumb(item) {
  const highlightValues = item._highlightResult.categories || [];
  return highlightValues.map(category => category.value).join(' > ');
}

function getStarsHTML(rating, maxRating) {
  let html = '';
  const newRating = maxRating || 5;

  for (let i = 0; i < newRating; ++i) {
    html += `<span class="ais-star-rating--star${
      i < rating ? '' : '__empty'
    }"></span>`;
  }

  return html;
}
